// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.update-leave-balance-container {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  padding: 10px 30px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  /* max-width: 600px; */
  margin: 20px auto;
  text-align: center;
  border: 1px solid #e0e0e0;
}

.update-leave-balance-container h2 {
  color: #333;
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: 600;
}

.form-section {
  margin-bottom: 20px;
  text-align: left;
}

.form-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #555;
  font-size: 16px;
}

.form-section input[type="text"],
.form-section input[type="file"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  box-sizing: border-box; /* Include padding in width */
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-section input[type="text"]:focus,
.form-section input[type="file"]:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: none;
}

/* Custom styling for file input appearance */
.form-section input[type="file"] {
  cursor: pointer;
  background-color: #f8f8f8;
}

.form-section input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
}

.form-section input[type="file"]::before {
  content: "Choose File";
  display: inline-block;
  background: #007bff;
  color: white;
  border: 1px solid #007bff;
  border-radius: 4px;
  padding: 8px 12px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.form-section input[type="file"]:hover::before {
  background-color: #0056b3;
}

.form-section input[type="file"]:active::before {
  background-color: #004085;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;
}

.upload-button,
.download-sample-button {
  padding: 12px 25px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  font-weight: 500;
}

.upload-button {
  background-color: #28a745; /* Green */
  color: white;
}

.upload-button:hover:not(:disabled) {
  background-color: #218838;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
}

.download-sample-button {
  background-color: #6c757d; /* Grey */
  color: white;
}

.download-sample-button:hover:not(:disabled) {
  background-color: #5a6268;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);
}

.upload-button:disabled,
.download-sample-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  box-shadow: none;
}

.message {
  margin-top: 20px;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 500;
}

.message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.excel-info {
  margin-top: 30px;
  padding: 15px;
  background-color: #e9ecef;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 15px;
  color: #495057;
  font-size: 14px;
  text-align: left;
}

.excel-info .excel-icon {
  font-size: 36px;
  color: #28a745; /* Green Excel icon */
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .update-leave-balance-container {
    margin: 20px auto;
    padding: 20px;
  }

  .action-buttons {
    flex-direction: column;
    gap: 10px;
  }

  .upload-button,
  .download-sample-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/UpdateLeaveBalance.css"],"names":[],"mappings":"AAAA;EACE,4DAA4D;EAC5D,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAE,6BAA6B;EACrD,wDAAwD;AAC1D;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;EAChD,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4DAA4D;EAC5D,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB,EAAE,SAAS;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,qBAAqB;AACvC;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".update-leave-balance-container {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n  padding: 10px 30px;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  /* max-width: 600px; */\n  margin: 20px auto;\n  text-align: center;\n  border: 1px solid #e0e0e0;\n}\n\n.update-leave-balance-container h2 {\n  color: #333;\n  margin-bottom: 20px;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.form-section {\n  margin-bottom: 20px;\n  text-align: left;\n}\n\n.form-section label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #555;\n  font-size: 16px;\n}\n\n.form-section input[type=\"text\"],\n.form-section input[type=\"file\"] {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 16px;\n  box-sizing: border-box; /* Include padding in width */\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-section input[type=\"text\"]:focus,\n.form-section input[type=\"file\"]:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  outline: none;\n}\n\n/* Custom styling for file input appearance */\n.form-section input[type=\"file\"] {\n  cursor: pointer;\n  background-color: #f8f8f8;\n}\n\n.form-section input[type=\"file\"]::-webkit-file-upload-button {\n  visibility: hidden;\n}\n\n.form-section input[type=\"file\"]::before {\n  content: \"Choose File\";\n  display: inline-block;\n  background: #007bff;\n  color: white;\n  border: 1px solid #007bff;\n  border-radius: 4px;\n  padding: 8px 12px;\n  outline: none;\n  white-space: nowrap;\n  -webkit-user-select: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.form-section input[type=\"file\"]:hover::before {\n  background-color: #0056b3;\n}\n\n.form-section input[type=\"file\"]:active::before {\n  background-color: #004085;\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.upload-button,\n.download-sample-button {\n  padding: 12px 25px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n  font-weight: 500;\n}\n\n.upload-button {\n  background-color: #28a745; /* Green */\n  color: white;\n}\n\n.upload-button:hover:not(:disabled) {\n  background-color: #218838;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);\n}\n\n.download-sample-button {\n  background-color: #6c757d; /* Grey */\n  color: white;\n}\n\n.download-sample-button:hover:not(:disabled) {\n  background-color: #5a6268;\n  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.2);\n}\n\n.upload-button:disabled,\n.download-sample-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.message {\n  margin-top: 20px;\n  padding: 10px 15px;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.excel-info {\n  margin-top: 30px;\n  padding: 15px;\n  background-color: #e9ecef;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  color: #495057;\n  font-size: 14px;\n  text-align: left;\n}\n\n.excel-info .excel-icon {\n  font-size: 36px;\n  color: #28a745; /* Green Excel icon */\n}\n\n/* Responsive adjustments */\n@media (max-width: 600px) {\n  .update-leave-balance-container {\n    margin: 20px auto;\n    padding: 20px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .upload-button,\n  .download-sample-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
